const $ = jQuery.noConflict();
import 'select2/dist/js/select2.full.js';

'use strict';
const Select2 = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$select: $('.js-select'),
	$selectBrands: $('.js-select-brands'),
	$selectCategories: $('.js-select-categories'),
	$selectStatus: $('.js-select-status'),
	$selectGravityForm: $('.request-quote-form-block__form select'),
	$selectCountryGravityForm: $('.request-quote-form-block__form .address_country select'),

	/** @description Initialize */
	init: function() {
		this.select2();
	},

	select2: () => {
		/**
		 * @description Select2 global function
		 * @link Documentation https://select2.org/
		 * @type {object}
		 */
		Select2.$select.select2({
			minimumResultsForSearch: -1,
			width: 'style',
			dropdownCssClass: 'custom-class'
		});
		Select2.$selectBrands.select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: 'select-dropdown-custom',
			placeholder: 'All Brands'
		});
		Select2.$selectCategories.select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: 'select-dropdown-custom',
			placeholder: 'All Categories'
		});
		Select2.$selectStatus.select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: 'select-dropdown-custom',
			placeholder: 'Select Status (optional)'
		});

		Select2.$selectGravityForm.select2({
			minimumResultsForSearch: -1,
			dropdownCssClass: 'application-form-select-dropdown',
		});

		Select2.$selectCountryGravityForm.select2({
			dropdownCssClass: 'application-form-select-dropdown',
			placeholder: 'Select Country *',
		});
	}
};

export default Select2;
